import React from "react";
import PropTypes from "prop-types";
import JobStatusWidget from "./JobStatusWidget";
import AccountManager from "./AccountManager";
import feedbackTimescaleOptionsType from "./types/feedbackTimescaleOptionsType";
import jobStatusWidgetType from "./types/jobStatusWidgetType";
import {
  JobProfileRightWrapper,
  Inner,
  SectionHeader,
  Section,
  SectionContent,
  MultiSection,
  MutiSectionItem,
  MapPlaceholder,
} from "./styles/job-profile-right-styles";

const JobProfileRight = ({
  jobStatus,
  dateCreated,
  location,
  postcode,
  feedbackTimescaleId,
  feedbackTimescaleOptions,
  accountManager,
  accountManagerAvatar,
  interviewComments,
  interviewStages,
  jobStatusWidget,
  isRecruiter,
  numberOfPositions,
}) => {
  const feedbackTimescaleType = feedbackTimescaleOptions.filter(
    (option) => option.id === feedbackTimescaleId
  )[0].name;

  return (
    <JobProfileRightWrapper>
      <Inner>
        <MultiSection>
          <MutiSectionItem>
            <SectionHeader>
              Job Status
              <JobStatusWidget
                jobStatusWidget={jobStatusWidget}
                isRecruiter={isRecruiter}
              />
            </SectionHeader>
            <SectionContent large>{jobStatus}</SectionContent>
          </MutiSectionItem>
          <MutiSectionItem>
            <SectionHeader>Date Created</SectionHeader>
            <SectionContent large>{dateCreated}</SectionContent>
          </MutiSectionItem>
        </MultiSection>
        {numberOfPositions > 1 && (
          <Section>
            <SectionHeader>Number of Positions</SectionHeader>
            <SectionContent large>{numberOfPositions}</SectionContent>
          </Section>
        )}
        <MultiSection>
          <MutiSectionItem>
            <SectionHeader>Feedback Timescale</SectionHeader>
            <SectionContent large>{feedbackTimescaleType}</SectionContent>
          </MutiSectionItem>
          <MutiSectionItem>
            <SectionHeader>Interview Stages</SectionHeader>
            <SectionContent large>{interviewStages}</SectionContent>
          </MutiSectionItem>
        </MultiSection>
        <Section>
          <SectionHeader>Location</SectionHeader>
          <SectionContent large>{location}</SectionContent>
        </Section>
        {postcode && (
          <Section>
            <SectionHeader>Post Code</SectionHeader>
            <SectionContent large>{postcode}</SectionContent>
          </Section>
        )}
        <Section>
          <MapPlaceholder>
            <iframe
              title="Map"
              src={`https://maps.google.com/maps?q=${
                postcode || location
              }&Roadmap&z=15&ie=UTF8&iwloc=&output=embed`}
              frameBorder="0"
              allowFullScreen
            />
          </MapPlaceholder>
        </Section>
        {interviewComments && (
          <Section>
            <SectionHeader>Interview Comments</SectionHeader>
            <SectionContent>{interviewComments}</SectionContent>
          </Section>
        )}
      </Inner>
      <AccountManager
        accountManager={accountManager}
        accountManagerAvatar={accountManagerAvatar}
      />
    </JobProfileRightWrapper>
  );
};

JobProfileRight.propTypes = {
  jobStatus: PropTypes.string.isRequired,
  dateCreated: PropTypes.string,
  location: PropTypes.string.isRequired,
  postcode: PropTypes.string,
  feedbackTimescaleId: PropTypes.number.isRequired,
  feedbackTimescaleOptions: feedbackTimescaleOptionsType.isRequired,
  accountManager: PropTypes.string.isRequired,
  accountManagerAvatar: PropTypes.string.isRequired,
  interviewComments: PropTypes.string,
  interviewStages: PropTypes.number.isRequired,
  jobStatusWidget: jobStatusWidgetType,
  isRecruiter: PropTypes.bool.isRequired,
  numberOfPositions: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

JobProfileRight.defaultProps = {
  interviewComments: null,
  jobStatusWidget: null,
  postcode: null,
  dateCreated: null,
  numberOfPositions: null,
};

export default JobProfileRight;
